import { useParams } from 'react-router-dom';
import { QuizAttemptProvider } from '../components/quiz-attempt/quiz-attempt-provider/quiz-attempt-provider.tsx';
import QuizAttempt from '../components/quiz-attempt/quiz-attempt.tsx';
import HighlightProvier from '../contexts/highlight-provider/index.tsx';

const QuizAttemptPage = () => {
  const params = useParams();
  const id = Number(params?.attemptId);

  return (
    <QuizAttemptProvider>
      <HighlightProvier>
        <QuizAttempt id={id} />
      </HighlightProvier>
    </QuizAttemptProvider>
  );
};

export default QuizAttemptPage;
